export const TERRITORIES = {
  west: 1,
  east: 2,
};
